import { Banner, Icon, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useGetPreviousYearInfo } from 'Containers/Filing/hooks';
import { TaxReturnTypes } from 'Containers/Result/utils';
import { ResultType } from 'Types/common';
import * as Styled from './styles';

const PreviousYearResultBanner = ({ data }: { data: ResultType }): JSX.Element => {
  const { t } = useTranslation(locizeNS.RESULT);
  const previousYearInfo = useGetPreviousYearInfo();
  return (
    <Styled.Container
      direction="column"
      fullWidth
      align="center"
      gap="dimension_16"
      $isMandatory={data.mandatory}
    >
      <Text type="paragraphs" size="M_L_S" color="dark">
        {data?.mandatory && data.taxReturnType === TaxReturnTypes.TO_PAY
          ? t('PreviousYear.Result.title.toPay')
          : t('PreviousYear.Result.title', { context: data.taxReturnType })}
      </Text>
      <Styled.AmountContainer align="center" justify="center" gap="dimension_16">
        <Icon icon="ShineL" color="warning" />
        <Text type="headline" size="S_L_S" color="fresh">
          {YayoyakiFormatter.formatAmountMxn(Math.abs(previousYearInfo?.amountPending ?? 0))}
        </Text>
        <Icon icon="ShineL" color="warning" />
      </Styled.AmountContainer>
      <Banner
        description={t('PreviousYear.Result.banner.description')}
        id="previous-year-banner"
        label={t('PreviousYear.Result.banner.title')}
        layout="embed"
        mode={data.mandatory ? 'default' : 'success'}
        position="vertically"
      />
    </Styled.Container>
  );
};

export default PreviousYearResultBanner;
